import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import React from 'react';
export const SourceIcon = React.memo(function SourceIcon({ sourceId, size = 'default', }) {
    const { getIcon } = useSourceMeta({ sourceId });
    return getIcon(size);
});
//# sourceMappingURL=SourceIcon.js.map